<script setup lang="ts">
import { ref } from "vue";
import { useAuthStore } from "@/features/auth/stores/auth-store";
import { needsMasterKeyReauth, clearMasterKeyFlag } from "@/shared/lib/auth-events";
import Modal from "@/shared/ui/Modal.vue";
import Button from "@/shared/ui/Button.vue";
import Input from "@/shared/ui/Input.vue";

const auth = useAuthStore();
const password = ref("");
const submitting = ref(false);
const localError = ref<string | null>(null);

async function submit(): Promise<void> {
  submitting.value = true;
  localError.value = null;
  const ok = await auth.unlock(password.value);
  submitting.value = false;
  if (ok) {
    password.value = "";
    clearMasterKeyFlag();
  } else {
    localError.value = auth.error ?? "Echec deverrouillage";
  }
}

function close(): void {
  // L'utilisateur peut fermer mais le flag reste, prochaine requete
  // declenchera a nouveau le dialog.
  clearMasterKeyFlag();
  password.value = "";
  localError.value = null;
}
</script>

<template>
  <Modal :open="needsMasterKeyReauth" title="Re-authentification requise" width="420px">
    <p>
      Ta cle maitresse n'est plus en memoire (probablement suite a un redeploiement back). Pour
      debloquer les operations sensibles (envoi, sync IMAP, dechiffrement credentials), saisis ton
      mot de passe maitre. Ta session reste valide.
    </p>
    <form class="form" @submit.prevent="submit">
      <Input
        v-model="password"
        type="password"
        autocomplete="current-password"
        placeholder="••••••••••••"
        :error="localError ?? ''"
      />
    </form>
    <template #footer>
      <Button variant="ghost" @click="close">Plus tard</Button>
      <Button
        variant="primary"
        :loading="submitting"
        :disabled="password.length < 4"
        @click="submit"
      >
        Deverrouiller
      </Button>
    </template>
  </Modal>
</template>

<style scoped>
.form {
  margin-top: 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}
</style>
